import {createContext, useContext, useMemo} from "react";
import {AreaEffect, AreaEffectType} from "@/encounter/model/AreaEffect.ts";
import Position from "@/util/Position.ts";
import {v4 as UUID} from "uuid";

export type AreaEffectUpdatePersistence = "immediate" | "debounced";

export type AreaEffectReturn = {
    effects: AreaEffect[];
    initialLoading: boolean;
    updateEffect: (effect: AreaEffect, persistence?: AreaEffectUpdatePersistence) => void;
    addEffect: (type: AreaEffectType) => Promise<void>;
    removeEffect: (effect: AreaEffect) => Promise<void>;
}

export const AreaEffectContext = createContext<AreaEffectReturn | null>(null);

export function useAreaEffect(): AreaEffectReturn {
    const res = useContext(AreaEffectContext);
    if (!res) {
        throw new Error("useAreaEffect must be used within a Provider");
    }
    return res;
}

export const fromType = (type: AreaEffectType, position: Position, levelId?: string): AreaEffect => {
    const base = {
        id: UUID(),
        name: "",
        type,
        position,
        levelId,
        hidden: true,
        highlighted: false,
        locked: false,
        color: "#000000",
        opacity: 0.5,
    }
    switch (type) {
        case "Rect":
            return {...base, rotation: -90, length: 6, width: 4}
        case "Arc":
            return {...base,  rotation: -90, radius: 4.5, width: 4.5, angle: 90}
        case "Sphere":
            return {...base, radius: 4.5}
    }

}


export function useCheckeredPattern(color: string, cellSize = 8): HTMLImageElement {
    return useMemo(() => {

        const dpr = window.devicePixelRatio || 1;
        const sizeCss = cellSize * 2;
        const sizePx = Math.round(sizeCss * dpr);

        const canvas = document.createElement("canvas");
        canvas.width = sizePx;
        canvas.height = sizePx;

        const ctx = canvas.getContext("2d");
        if (!ctx) throw new Error("2D context not available");

        ctx.scale(dpr, dpr); // jetzt in CSS-Pixeln zeichnen

        // Wichtig: NICHT füllen -> bleibt transparent
        ctx.clearRect(0, 0, cellSize, cellSize);

        ctx.fillStyle = color;
        ctx.fillRect(0, 0, cellSize, cellSize);
        ctx.fillRect(cellSize, cellSize, cellSize, cellSize);

        return canvas as unknown as HTMLImageElement;
    }, [cellSize, color])
}
